module.exports = __webpack_public_path__ + "a697ee249adf66f94effc61b8132aaf4.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/projekte/mythos-2.jpg
// module id = 526
// module chunks = 0